import { TrimTextPipe } from "@/shared/pipes/trim-text/trim-text.pipe";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [
    TrimTextPipe,
  ],
  exports: [
    TrimTextPipe,
  ],
  imports: [
    CommonModule,
  ],
})
export class TrimTextModule { }
